const logger = require('./logger.js')
const config = require('./config.js')
import common from '../methods/common.js'
require('./cryptojs/cryptojs.js') // code executes and sets the object 'Crypto' in window object
let crypto = window.Crypto
// const HOST = '/api/ikey/mng/'
const HOST = '/api/'
function doRequest (url, data, client, succCallback, failCallback) {
  let protocolUnit = {
    'id': makeId(),
    'sign': makeSign(config.caller, config.secretKey, data),
    'client': Object.assign({
      caller: config.caller,
      ts: Date.now() / 1000,
      session: common.session()
    }, client),
    'data': data
  }
  logger.debug('url: ' + (HOST + url) + ', data:' + JSON.stringify(protocolUnit))
  window.$.ajax({
    type: 'POST',
    url: HOST + url,
    contentType: 'application/json;charset=utf-8',
    data: JSON.stringify(protocolUnit),
    // timeout: 5000,
    success: function (resp) {
      logger.debug('resp: ' + JSON.stringify(resp))
      if (resp.state.code === 2000000 && resp.state.result === 0) {
        succCallback(resp.data)
      } else {
        if (failCallback && typeof failCallback === 'function') {
          failCallback(resp.state)
        } else {
          logger.info('no handler for request[' + url + '] fail!, state:' + JSON.stringify(resp.state))
        }
      }
    },
    error: function (xhr, status, error) {
      console.log('errCallback' + error)
      if (failCallback) {
        failCallback(error)
      } else {
        console.error(error)
      }
    },
    statusCode: {
      404: function () {
        console.log('page not found')
      }
    }
  })
}

function makeId () {
  let text = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < 20; i++) {
    let index = Math.floor(Math.random() * 62)
    text = text + possible[index]
  }
  return text
}

function makeSign (caller, key, dataJson) {
  if (!dataJson) {
    return crypto.MD5(caller + key)
  } else {
    let keys = getSortedKeys(dataJson)
    let dataStr = ''
    let val = ''
    for (let k in keys) {
      val = keys[k]
      dataStr = dataStr + val + '=' + getAsString(dataJson[val])
    }
    logger.debug('dataStr = ' + dataStr)
    let sign = crypto.MD5(caller + dataStr + key)
    // logger.debug('sign = ' + sign)
    return sign
  }
}

function getSortedKeys (obj) {
  let keysArr = []
  for (let key in obj) {
    keysArr.push(key)
  }
  keysArr.sort()
  return keysArr
}

function getAsString (elem) {
  if (elem === undefined) {
    return ''
  }
  if (!elem) {
    return elem
  }
  if (Array.isArray(elem)) {
    let buf = []
    for (let index in elem) {
      buf.push(getAsString(elem[index]))
    }
    return buf.join(',')
  } else if (typeof elem === 'string') {
    return elem
  } else {
    return JSON.stringify(elem)
  }
}
function doRequest0 (url, data, succCallback, failCallback) {
  doRequest(url, data, {}, succCallback, failCallback)
}
module.exports = {
  post: doRequest,
  invoke: doRequest0
}



// WEBPACK FOOTER //
// ./src/lib/utils/request.js